import { Minute } from '@nu-art/ts-common';
import { HttpMethod } from '../types.js';
export const Const_SyncEnv_SourceProd = 'prod';
export const Const_SyncEnv_ChunkSize = 500;
export const resolveDeltaQueryFlag = (value, defaultValue) => {
    if (value === undefined)
        return defaultValue;
    if (value === true || value === 'true')
        return true;
    if (value === false || value === 'false')
        return false;
    return defaultValue;
};
export const ApiDef_SyncEnv = {
    vv1: {
        getLatestBackup: { method: HttpMethod.GET, path: 'v1/sync-env/get-last-backup-id' },
        syncToEnv: { method: HttpMethod.POST, path: 'v1/sync-env/sync-to-env', timeout: 5 * Minute },
        syncFromEnvBackup: { method: HttpMethod.POST, path: 'v1/sync-env/fetch-from-env-v2', timeout: 5 * Minute },
        getLatestBackupDelta: { method: HttpMethod.POST, path: 'v1/sync-env/get-latest-backup-delta', timeout: 5 * Minute },
        syncLatestFromEnv: { method: HttpMethod.POST, path: 'v1/sync-env/sync-latest-from-env', timeout: 5 * Minute },
        getSyncableCollections: { method: HttpMethod.GET, path: 'v1/sync-env/get-syncable-collections' },
        createBackup: { method: HttpMethod.GET, path: 'v1/sync-env/create-backup-v2', timeout: 5 * Minute },
        fetchBackupMetadata: { method: HttpMethod.GET, path: 'v1/sync-env/fetch-backup-metadata', timeout: 5 * Minute },
        syncFirebaseFromBackup: { method: HttpMethod.GET, path: 'v1/sync-env/fetch-firebase-backup', timeout: 5 * Minute }
    }
};
//# sourceMappingURL=apis.js.map